module.exports = __webpack_public_path__ + "static/atmosplay-1f11bf27c25e4422e54c85d09c97749a.png";